import styled from 'styled-components';

export const StyledIcd9ProcedureTable = styled.div`
   z-index: 1;
`;
StyledIcd9ProcedureTable.displayName = 'StyledIcd9ProcedureTable';
